export class GlobalVariables {
    //public static appURL: string = "http://localhost:3000/";
    public static appURL: string = "http://52.15.132.22:3000/";
    public static couponShareURL: string = "https://share.scanfluence.com/";
  }
  